module.exports = __webpack_public_path__ + "img/icon-velans-le_canyon.80f7d97.png";